import * as React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.scss";

import AppLayout from "./components/AppLayout";
// import CurrentMovieForm from "./components/MovieInputs/CurrentMovieForm";
// import logo from './logo.svg';

// base path to api process.env.REACT_APP_BASE_URL

class App extends React.Component {
  public render() {
    return (
      <Router>
        <div className="App">
          <AppLayout />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx